<div class="flex flex-col items-end justify-between md:flex-row">
  <div>
    <p class="text-typography-default">{{ 'common.welcome' | transloco: { user: firstName() } }}</p>
    <h1 class="font-bold !text-5xl text-typography-default" *authRole="[Role.USER]">
      {{ 'navbar.welcome.description' | transloco }}
    </h1>
    <h1 class="font-bold !text-5xl text-typography-default" *authRole="[Role.ADMIN, Role.ANALYST]">
      {{ 'navbar.welcome.description.admin' | transloco }}
    </h1>
  </div>

  <a [routerLink]="['/search']" class="flex items-end text-typography-default !no-underline">
    <h2>{{ 'navbar.welcome.cta' | transloco }}</h2>
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <path
        d="M51.9802 36.2481L31.7512 36.2481L31.7512 30.9148L61.0847 30.9148L61.0845 60.2481L55.7512 60.2481L55.7514 40.0193L32.8004 62.9703L29.0292 59.1991L51.9802 36.2481Z"
        fill="#FBFBFB"
      />
    </svg>
  </a>
</div>
